import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';

export const userRegisteredGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.hasUserAnyPermission()) {
    return true;
  }

  return router.createUrlTree(['/no-permission']);
};
